<template>
    <v-select class="select"
              name="assignedInspector"
              :clearable="false"
              placeholder="Change Inspector"
              v-model="selectedInspector"
              style="min-width: 200px;"
              @input="handleChange"
              :options="inspectorsForSelect"
              :selectable="inspector => inspector.available">
      <template #option="{ label, value, available }">
        <span :class="available ? '' : 'unavailable-option'">{{label}} {{available ? "" : "(AWAY)"}}</span>
      </template>
    </v-select>
</template>

<script>
import vSelect from 'vue-select'
import {mapGetters} from 'vuex'

export default {
  props: ['assignedInspector'],
  emits: ['inspector-changed'],
  components: {vSelect},
  computed: {
    ...mapGetters({
      inspectorsForSelect: 'inspectorRouting/inspectorsForSelect'
    }),
  },
  data() {
    return {
      selectedInspector: null
    }
  },
  methods: {
    handleChange(inspector) {
      this.$emit('inspector-changed', inspector)
    }
  },
  beforeMount() {
    this.selectedInspector = this.assignedInspector || null;
  },
  watch: {
    assignedInspector: {
      handler: function(assignedInspector) {
        this.selectedInspector = assignedInspector
      }
    }
  }
}
</script>

<style scoped>
>>> .unavailable-option {
  color: #AAAAAA;
}

>>>.vs__dropdown-menu {
  max-height: 175px;
}
</style>
